import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyMemberOption} from '../../../graphql/groups.datatypes';

interface RoomPartyMemberOptionInput {
    id: number
    room_party_member_id: number
    group_resource_option_id: number
    unit_count: number
    unit_cost: number
    admin_edited: boolean
}

interface RoomPartyMemberOptionInputBulk {
    group_resource_option_id: number
    action: 'increment' | 'decrement',
    room_party_members: number[]
}

export interface UpdateRoomPartyMemberOptionInput {
    data: RoomPartyMemberOptionInput
}

export interface UpdateRoomPartyMemberOptionInputBulk {
    data: RoomPartyMemberOptionInputBulk
}

interface UpdateRoomPartyMemberOptionData {
    updateRoomPartyMemberOption: RoomPartyMemberOption,
}

interface UpdateRoomPartyMemberOptionDataBulk {
    updateRoomPartyMemberOptionBulk: RoomPartyMemberOption[]
}

export const UPDATE_ROOM_PARTY_MEMBER_OPTION_MUTATION = gql`
  mutation updateRoomPartyMemberOption($data: UpdateRoomPartyMemberOptionInput!){
    updateRoomPartyMemberOption(data: $data) {
      id
      room_party_member_id
      group_resource_option_id
      unit_count
      unit_cost
      admin_edited
    }
  }
`;

export const UPDATE_ROOM_PARTY_MEMBER_OPTION_MUTATION_Bulk = gql`
    mutation updateRoomPartyMemberOptionBulk($data: UpdateRoomPartyMemberOptionInputBulk!){
        updateRoomPartyMemberOptionBulk(data: $data) {
            id
            room_party_member_id
            group_resource_option_id
            unit_count
            unit_cost
            admin_edited
        }
    }
`;

export const updateRoomPartyMemberOption = () => {
    return useMutation<UpdateRoomPartyMemberOptionData, UpdateRoomPartyMemberOptionInput>(
        UPDATE_ROOM_PARTY_MEMBER_OPTION_MUTATION,
        {
            update: updateCacheByType('RoomPartyMemberOption'),
        }
    );
};

export const updateRoomPartyMemberOptionBulk = () => {
    return useMutation<UpdateRoomPartyMemberOptionDataBulk, UpdateRoomPartyMemberOptionInputBulk>(
        UPDATE_ROOM_PARTY_MEMBER_OPTION_MUTATION_Bulk,
        {
            update: updateCacheByType('RoomPartyMemberOption'),
        }
    );
};

export default {
    updateRoomPartyMemberOption,
    updateRoomPartyMemberOptionBulk,
};
